<template>
  <div class="container">
    <div class="info-to-know">
      <div class="inner-container">
        <div class="info">
          <p class="title">{{ $t("personalArea.diskInfo.diskCap") }}</p>
          <p class="content">{{ totalTB }}TB</p>
        </div>
      </div>
      <div class="meta-info">
        <p style="color: #a7610f">
          • {{ $t("personalArea.diskInfo.diskUsed") }}
        </p>
        <p style="color: rgba(167, 97, 15, 0.5)">
          • {{ $t("personalArea.diskInfo.diskFree") }}
        </p>
      </div>
    </div>
    <div class="disksizeinfo">
      <span class="occupied">{{ this.tbfree }}TB</span>
      <canvas id="pa_disk" ref="disk" width="86" height="84"></canvas>
      <span class="free">{{ this.tbtotal }}TB</span>
    </div>
  </div>
</template>

<script>
import { Axios } from "@/services/_axios";

export default {
  data() {
    return {
      free: 0,
      total: 0,
    };
  },
  computed: {
    tbfree() {
      return this.bytesToTerabytes(this.free);
    },
    tbtotal() {
      return this.bytesToTerabytes(this.total);
    },
    totalTB() {
      return Math.ceil(this.bytesToTerabytes(this.total));
    },
  },
  async mounted() {
    const data = await Axios.get("/api/personalarea/disk-info");
    if (data.data) {
      const spl = data.data.split("="); //0 = total | 1= free
      this.total = Number(spl[0]);
      this.free = Number(spl[1]);
      this.draw(this.free, this.total, this.totalTB + "TB");
    }
  },
  methods: {
    bytesToTerabytes(bytes) {
      return (bytes / 1024 / 1024 / 1024 / 1024).toFixed(2);
    },

    draw(freespace, totalSize, txt) {
      let max = 2 * Math.PI;
      let prec = max / 100;
      let x = totalSize / 100;
      x = freespace / x;
      let freeToDraw = x * prec;
      let totalToDraw = x * prec;

      const c = this.$refs.disk; //document.getElementById("pa_disk");
      const ctx = c.getContext("2d");
      ctx.beginPath();
      ctx.lineWidth = 16;
      let rad = 33;
      ctx.strokeStyle = "#A7610F";
      // ctx.arc(43, 42, rad, 1.8, max);
      ctx.arc(43, 42, rad, totalToDraw + 0.03, max);
      ctx.stroke();

      ctx.beginPath();
      // ctx.arc(43, 42, rad, max + 0.02, 1.78);
      ctx.arc(43, 42, rad, max + 0.03, freeToDraw);
      ctx.strokeStyle = "#d3b087";
      ctx.stroke();

      ctx.font = "700 11px Heebo";
      ctx.textAlign = "center";
      ctx.fillText(txt, 44, 44);
    },
  },
};
</script>

<style lang="scss" scoped>
.container * {
  margin: 0px;
}
.meta-info {
  display: flex;
  align-self: stretch;
  flex-direction: column;
  font-size: 11px;
  font-style: normal;
  font-weight: 700;
  line-height: 120%;
}

.inner-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
}
.info-to-know {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex: 1 0 0;
  height: 86px;
  flex-direction: column;
}
.info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
}
.title {
  color: #7b7b7b;

  /* label */

  font-size: 11px;
  font-style: normal;
  font-weight: 700;
  line-height: 120%; /* 13.2px */
}
.content {
  color: #000;
  padding: 0px 3px;
  /* otzar body */

  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%; /* 15.6px */
}
.occupied {
  color: #a7610f;
  font-size: 11px;
  font-style: normal;
  font-weight: 700;
  display: flex;
  align-items: flex-end;
  padding-bottom: 6px;
}
.free {
  color: #a7610f;
  font-size: 11px;
  font-style: normal;
  font-weight: 700;
  display: flex;
  align-items: flex-start;
  padding-top: 10px;
}
.container {
  display: flex;
  padding: 8px 0px;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #dedede;
}
.disksizeinfo {
  width: 151.432px;
  height: 86.232px;
  flex-shrink: 0;
  display: flex;
}
</style>
